import { createStyles, makeStyles } from '@material-ui/core/styles';
import Colors from '../../layout/theme/utils/colors';

const useDeviationProcedureStyles = makeStyles(() =>
  createStyles({
    panelBorder: {
      marginBottom: 5,
      border: `1px solid ${Colors.gray_goose}`,
      borderRadius: '4px',
    },
    panelSummary: {
      flexDirection: 'row-reverse',
      padding: '0 16px',
      minHeight: '48px',
      alignItems: 'center',
      '& .MuiAccordionSummary-expandIcon': {
        marginRight: 4,
        marginLeft: 0,
        padding: 8,
      },
      '& .Mui-expanded': {
        transform: 'rotate(0deg)',
      },
    },
    labelContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    stepCountLabel: {
      fontSize: 12,
      color: Colors.hint_gray,
      whiteSpace: 'nowrap',
      marginLeft: 8,
    },
    deviatedBadge: {
      fontSize: 11,
      fontWeight: 700,
      color: Colors.red,
      marginLeft: 8,
      whiteSpace: 'nowrap',
    },
    stepCaption: {
      fontWeight: 600,
    },
    stepLabelText: {
      fontWeight: 700,
      whiteSpace: 'nowrap' as const,
    },
    mpiLabelText: {
      fontWeight: 400,
      marginLeft: 4,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap' as const,
    },
    accordionDetails: {
      display: 'block',
    },
  }),
);

export default useDeviationProcedureStyles;
